/**
 * Single PDP <h1 data-pdp-product-title>:
 * - Mobile (≤600px, not sticky): above gallery [data-pdp-title-mobile]
 * - Desktop / sticky ATC: buy box [data-pdp-title-desktop]
 *
 * IMPORTANT: Do NOT use document.querySelector('.sticky-atc') — that node
 * always exists in the header. Use body.sticky-add-to-cart instead.
 */
(function () {
  if (window.__zinusPdpTitleHeading) return;
  window.__zinusPdpTitleHeading = true;

  var MOBILE_MQ = '(max-width: 600px)';

  function isStickyActive() {
    return !!(
      document.body &&
      document.body.classList.contains('sticky-add-to-cart')
    );
  }

  function isHybridActive() {
    var hybrid = document.querySelector('.zin-hybrid:not(.hidden)');
    var hybridMobile = document.querySelector('.zin-hybrid-mobile:not(.hidden)');
    return !!(hybrid || hybridMobile);
  }

  function syncTitleText(h1) {
    if (!h1) return;
    var next = isHybridActive()
      ? h1.getAttribute('data-title-hybrid')
      : h1.getAttribute('data-title-foam');
    if (next != null && h1.textContent !== next) {
      h1.textContent = next;
    }
  }

  function placeTitle() {
    var h1 = document.querySelector('[data-pdp-product-title]');
    var desktopSlot = document.querySelector('[data-pdp-title-desktop]');
    var mobileSlot = document.querySelector('[data-pdp-title-mobile]');
    if (!h1 || !desktopSlot || !mobileSlot) return;

    syncTitleText(h1);

    var isMobile = window.matchMedia(MOBILE_MQ).matches;
    var sticky = isStickyActive();

    if (isMobile && !sticky) {
      if (h1.parentElement !== mobileSlot) {
        mobileSlot.appendChild(h1);
      }
    } else if (h1.parentElement !== desktopSlot) {
      desktopSlot.appendChild(h1);
    }
  }

  function init() {
    placeTitle();

    document.addEventListener(
      'click',
      function (ev) {
        if (!ev.target || !ev.target.closest) return;
        if (
          ev.target.closest(
            '.zin-material-radio-1, .zin-material-radio-2, .zin-material-label, [name="material-radio"]'
          )
        ) {
          window.setTimeout(placeTitle, 0);
        }
      },
      true
    );

    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE_MQ);
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', placeTitle);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(placeTitle);
      }
    }

    window.addEventListener('resize', placeTitle);

    // Sticky ATC toggles body.sticky-add-to-cart — watch that only.
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(placeTitle);
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var header = document.getElementById('SiteHeader');
      if (header) {
        mo.observe(header, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
